// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.scss\"","smallWidth":"768px","button":"SliderArrow_button__30fXd","arrow":"SliderArrow_arrow__H34uk"};